import * as THREE from 'three';

export function createLighting(shadowSize: number): THREE.Group {
  const group = new THREE.Group();
  group.add(new THREE.HemisphereLight(0xa8d8ff, 0x101522, 1.75));
  const key = new THREE.DirectionalLight(0xe1f3ff, 3.6);
  key.position.set(-7, 15, 9);
  key.castShadow = true;
  key.shadow.mapSize.set(shadowSize, shadowSize);
  key.shadow.camera.left = -18;
  key.shadow.camera.right = 18;
  key.shadow.camera.top = 14;
  key.shadow.camera.bottom = -14;
  key.shadow.bias = -0.0003;
  group.add(key);
  const fill = new THREE.DirectionalLight(0x2d77ff, 1.1);
  fill.position.set(12, 7, -10);
  group.add(fill);
  return group;
}
